import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import { updateBolsa, updateStatusBolsa } from '../actions'
import { getBolsa, getRedirect } from '../reducers'
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    CircularProgress,
    useColorModeValue,
    Card
} from '@chakra-ui/react'
import { Formik } from 'formik'
import { FormValidator } from '../utils/validationForms'
import Layout from '../layout'
import Editor from "../components/Editor"
import "../styles.css"


const BolsaEdit = () => {

    const [html, setHTML] = useState("")
    const [mounted, setMounted] = useState(false)
    const [editorSetted, setEditorSetted] = useState(false)
    const [editor, setEditor] = useState(null)
    const dispatch = useDispatch()
    const redirect = useSelector(state => getRedirect(state))

    const [post_id] = useState(useParams("id").id)
    const post = useSelector(state => getBolsa(state, post_id))
    const color = useColorModeValue('white', 'gray.800')

    useEffect(() => {
        setHTML(post.description)
        setMounted(true)
    }, [])

    if (redirect) {
        return <Redirect to="/bolsa" />
    }

    return (
        <Layout>

            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <h1>Cambio de información</h1>
                <hr />
                <br />
                <Formik
                    initialValues={{
                        title: post.title
                    }}
                    validate={values => FormValidator([
                        { field: 'Titulo', value: values.title, rules: ['required'] }
                    ])}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        const formData = new FormData()
                        for (let value in values) {
                            formData.append(value, values[value])
                        }
                        formData.append('id', post.id)
                        formData.append('description', html)
                        Promise.resolve(dispatch(updateBolsa(formData, post.id)))
                            .then(() => {
                                setSubmitting(false)
                            })
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>

                            <FormControl isInvalid={errors.title && touched.title}>
                                <FormLabel>Titulo</FormLabel>
                                <Input name="title" onChange={handleChange} onBlur={handleBlur} value={values.title} />
                                <FormErrorMessage>{errors.title}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.description && touched.description}>
                                <FormLabel>descripción</FormLabel>
                                <Card>
                                    {mounted ?
                                        <Editor placeholder={"Contenido"} setHTML={setHTML} setEditor={setEditor} initialHtml={html} setEditorSetted={setEditorSetted} editorSetted={editorSetted} />
                                        : <>Loading</>
                                    }
                                </Card>
                            </FormControl>

                            <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress /> : 'Actualizar'}
                            </Button>
                        </form>
                    )}
                </Formik>

            </Box>

            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <h1>Estado de vacante</h1>
                <hr />
                <br />
                <Button onClick={() => {
                    dispatch(updateStatusBolsa(post.id))
                }} colorScheme="easycar2" type="submit" mt={4} > {post.active ? "Ocultar" : "Activar"} </Button>
            </Box>
        </Layout >
    )
}

export default BolsaEdit
